import React, { useRef } from 'react';
import Icon from '@ant-design/icons';
import { Tooltip, Tag } from 'antd';

import css from './style.less';

function ErrorFill({ fill }) {
  return (
    <svg
      t="1636341545722"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="17914"
      width="1em"
      height="1em"
      style={{ color: 'orange' }}>
      <path
        d="M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416z m32 352c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
        p-id="17915"
        fill={fill}
      />
    </svg>
  );
}

const TAG_CONTENT = [
  {
    text: '机器人未识别',
    hoverText: '机器人未识别消息，需手动回复该条消息',
    style: {
      color: '#FF8806',
      background: 'rgba(255,161,6,0.10)'
    }
  },
  {
    text: '机器人未识别 - 已回复',
    hoverText: '机器人未识别消息，已回复该条消息',
    style: {
      color: '#15C292',
      background: '#E7F8F4'
    }
  },
  {
    text: '机器人未识别 - 已忽略',
    hoverText: '机器人未识别消息，已忽略该条消息',
    style: {
      background: 'rgba(133,67,224,0.10)',
      color: '#8543E0'
    }
  },
  {
    text: '命中拦截词',
    hoverText: '该条消息命中拦截词，机器人不进行回复',
    style: {
      color: '#FF8806',
      background: 'rgba(255,161,6,0.10)'
    }
  }
];

export function TrusteeshipTag({ type }) {
  const { hoverText, text, style } = TAG_CONTENT[type];
  const containerDomRef = useRef();

  return (
    <span className={css.tooltip} ref={containerDomRef}>
      <Tooltip getPopupContainer={() => containerDomRef.current} title={hoverText}>
        <Tag className={css.tag} style={style}>
          <Icon>
            <ErrorFill fill={style.color} />
          </Icon>
          {text}
        </Tag>
      </Tooltip>
    </span>
  );
}
